/**
 * file : Componentization.jsx
 * 설명 : 컴포넌트 모음
 */

import arrow_prev2 from "assets/images/arrow_prev2.png"
import arrow_prev1 from "assets/images/arrow_prev1.png"
import arrow_next1 from "assets/images/arrow_next1.png"
import arrow_next2 from "assets/images/arrow_next2.png"

import $ from 'jquery';
import { Fnc } from 'common/globals';
import { Link } from 'react-router-dom';
import React, { useEffect, useRef } from 'react';
import { ColorRing } from 'react-loader-spinner';

/**
 * 스피너
 * @param {boolean} show 보여짐 여부
 */
const Spinner = ({ show }) => {
  return (
    <div className={`${show ? 'spiner-loading' : null}`}>
      <ColorRing
        visible={show}
        height="80"
        width="80"
        colors={['rgba(207, 50, 200, 1)', 'rgba(255, 92, 11, 1)', 'rgba(207, 50, 200, 1)', 'rgba(255, 92, 11, 1)', 'rgba(207, 50, 200, 1)']}
      />
    </div>
  )
}
/**
 * 입력 필드
 * @param {String} elementKey 해당 엘리먼트 고유 key 값
 * @param {String} placeholder 입력 전 보여질 값
 * @param {Function} insert 값 할당
 * @param {String} inputStyle 스타일 (기본 값: null)
 */
const Input = ({ elementKey, placeholder, insert, inputStyle = null }) => {
  return (
    <input
      type="text"
      placeholder={placeholder}
      className={inputStyle}
      onChange={(e) => {insert(elementKey, e.target.value)}}
    />
  )
}
/**
 * 셀렉트
 * @param {String} elementKey 해당 엘리먼트 고유 key 값
 * @param {String} placeholder 입력 전 보여질 값 (value: null)
 * @param {Array} options 옵션 데이터
 * @param {selected} selected 선택된 값
 * @param {Function} insert 값 할당
 */
const Select = ({ elementKey, placeholder, options, selected, insert }) => {
  return (
    <div>
      <select className="form-select" name="" onChange={(e) => insert(elementKey, e.target.value)} >
        <option value={''}>{placeholder}</option>
        {options.map((item) => (
          <option value={item.value} key={item.value}>{item.name}</option>
        ))}
      </select>
    </div>
  )
}
/**
 * 파일 업로드 컴포넌트 (다수 업로드 가능)
 * @param {Array} fileDatas 파일 데이터
 * @param {Function} handleFiles 파일 업로드 함수
 */
const DropFileZone = ({ fileDatas, handleFile }) => {

  const fileInputRef = useRef(null);
  // 파일 추가
  const fileAdd = (e) => {
    e.preventDefault();
    
    let reader = new FileReader();
    const file = e.target.files ? e.target.files[0] : e.dataTransfer.files[0];
debugger
    reader.onload = () => {
      handleFile((item) => ({
        ...item,
        images: [
          ...item.images,
          {
            'key': Fnc.RandomKey(),
            'image': reader.result.replace('data:', '').replace(/^.+,/, ''),
            'preview': reader.result,
            'imagename': file.name,
            'imagefiletype': file.type.split('/')[1],
            'formattedSize': `${(file.size / 1024).toFixed(2)}KB`
          }
        ]
      }))
    };
    reader.readAsDataURL(file);
  };
  // 파일 삭제 
  const deleteFiles = (e) => {
    handleFile((item) => ({
      ...item,
      images: fileDatas.filter((file) => file.key !== e.key)
    }))
  }

  return (
    <div className="fileDropWrap" onDragOver={(e) => e.preventDefault()} onDrop={fileAdd}>
      <ul>
        {fileDatas.map((item) => {
          return (
            <li key={item.key}>
              <div onClick={() => deleteFiles(item)}><span className="material-icons">close</span></div>
              <p><img src={item.preview} alt="Selected" /></p>
            </li>
          )
        })}
      </ul>
      <input type="file" style={{ display: 'none' }} ref={fileInputRef} onChange={fileAdd} />
      <Link className="filebtn" onClick={() => fileInputRef.current.click()}>
        파일첨부 <span className="material-icons">add</span>
      </Link>
      <p>Drag & Drop Files Here</p>
    </div>
  )
}
 /**
 * 페이징 처리
 * @param {Object} pageData 페이징 데이터
 * @param {Function} PageChange 페이징 처리 함수
 */
const Paging = ({ pageData, PageChange }) => {

  if (Fnc.Empty(pageData)) return null;
  // 현재 페이지 그룹
  const currentPageGroup = Math.ceil(pageData.current_page / 5); 
  // 그룹의 시작 페이지
  const startPage = (currentPageGroup - 1) * 5 + 1; 
  // 그룹의 마지막 페이지 (실제 마지막 페이지를 넘지 않도록 조정)
  const endPage = Math.min(startPage + 4, pageData.last_page); 
  // 페이지 번호 
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(
      <li key={i} onClick={() => PageChange('page', i)}>
        <Link className={pageData.current_page === i ? 'active' : null}>{i}</Link>
      </li>
    );
  }

  return (
    <div className="pagecut">
      <ul>
        {/* 처음 버튼 */}
        <li onClick={() => pageData.current_page !== pageData.from && PageChange('page', 1)}> <img src={arrow_prev2} alt="이전 맨끝" /></li>
        {/* 이전 버튼 */}
        <li onClick={() => pageData.current_page !== pageData.from && PageChange('page', pageData.current_page - 1)}><img src={arrow_prev1} alt="이전" /></li>
        {/* 페이지 번호 */}
        {pageNumbers}
        {/* 다음 버튼 */}
        <li onClick={() => pageData.current_page !== pageData.last_page && PageChange('page', pageData.current_page + 1)}><img src={arrow_next1} alt="다음" /></li>
        {/* 마지막 버튼 */}
        <li onClick={() => pageData.current_page !== pageData.last_page && PageChange('page', pageData.last_page)}><img src={arrow_next2} alt="다음 맨끝" /></li>
      </ul>
    </div>
  )
}
/**
 * Tab
 * @param {Array} title Tab 제목
 * @param {Array} content Tab 내용
 * @param {Array} style 스타일
 */
const Tab = ({ title, content, style = null }) => {
  useEffect(() => {
    var tabs = $('.zeus-tab');

    tabs.each(function() {
      var tabDiv = $(this);
      tabDiv.on('click', 'li', function() {
        if ( /tab-current/.test(this.className) ) return;
        var liEle = $(this);
        var index = liEle.parent().children().index(liEle);
        liEle.siblings().each(function() {
        $(this).removeClass('tab-current');
        });
        liEle.addClass('tab-current');
        var content = liEle.parent().next();
        content.children().each(function() {
        $(this).removeClass('tab-show');
        });
        content.children().eq(index).addClass('tab-show');
        var callback = liEle.parent().parent().attr('onchage');
        if (callback) eval(callback + '(liEle, index)');
      });
    });
  })

  return (
    <div id="tab1" className="zeus-tab">
      <ul className={`zeus-tab-title ${style}`}>
        {
          title.map((item, index) => (
            <li className={ index === 0 ? `tab-current` : null} key={index}>{item}</li>
          ))
        }
      </ul>
      <div className="zeus-tab-content">
        {
          content.map((item, index) => (
            <React.Fragment key={index}>{item}</React.Fragment>
          ))
        }
      </div>
    </div>
  )
}

export { DropFileZone, Paging, Input, Tab, Spinner, Select }
